/** Primeiro segmento da URL — não pode ser loja pública (evita colidir com rotas do app). */
export const RESERVED_STORE_SLUGS = new Set([
  '',
  'cadastro',
  'login',
  'app',
  'admin',
  'api',
  'store',
  'loja',
  'assets',
  'src',
  'dist',
  'health',
  'recuperar-senha',
  'redefinir-senha',
  'favicon.ico',
]);

export function isReservedStoreSlug(slug) {
  if (!slug || typeof slug !== 'string') return true;
  const s = slug.trim().toLowerCase();
  return RESERVED_STORE_SLUGS.has(s) || s.includes('/') || s.includes('..');
}
